import { render, staticRenderFns } from "./dropdownFilters.vue?vue&type=template&id=8a1a055e&"
import script from "./dropdownFilters.vue?vue&type=script&lang=js&"
export * from "./dropdownFilters.vue?vue&type=script&lang=js&"
import style0 from "./dropdownFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports